<template>
	<div class="terms-page">
		<div class="container">
			<template v-if="$store.state.campaign">
				<div class="terms" v-html="$store.state.campaign.terms"></div>
			</template>
		</div>
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.terms-page {
	width: 100%;
	font-size: 18px;

	.terms {
		margin: 50px 0;
	}
}
</style>
